export const enum ActionStatusEnum {
  success = "success",
  error = "error",
}

export const enum WebviewActionEnum {
  uploadfile = "rn-to-web-uploadfile",
}
